import { render } from "./LinkageProfileComplete.vue?vue&type=template&id=e990612a&ts=true"
import script from "./LinkageProfileComplete.vue?vue&type=script&lang=ts"
export * from "./LinkageProfileComplete.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src1364277118/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__